//@ts-check

const PAUSE_REASON = "arrow-hover";

/**
 * The part of SlideshowConductor the arrows rely on.
 * @typedef {object} NavigationConductor
 * @property {() => void} next
 * @property {() => void} prev
 * @property {(reason: string) => void} pause
 * @property {(reason: string) => void} resume
 */

/**
 * Prev/next arrow buttons of one slideshow.
 * A click steps all slideshows via the conductor,
 * then pauses them until the pointer leaves that arrow.
 */
export class SlideshowNavigation {
  /**
   * @param {HTMLElement} element the .slideshow root
   * @param {NavigationConductor} conductor
   */
  constructor(element, conductor) {
    this.element = element;
    this.conductor = conductor;
    /** @type {Array<() => void>} */
    this.cleanups = [];
  }

  init() {
    this._bind(".slideshow-nav--prev", () => this.conductor.prev());
    this._bind(".slideshow-nav--next", () => this.conductor.next());
  }

  destroy() {
    this.cleanups.forEach((cleanup) => cleanup());
    this.cleanups = [];
    this.conductor.resume(PAUSE_REASON);
  }

  /**
   * @param {string} selector
   * @param {() => void} step
   */
  _bind(selector, step) {
    const button = this.element.querySelector(selector);
    if (!button) return;

    const onClick = () => {
      step();
      this.conductor.pause(PAUSE_REASON);
    };
    const onLeave = () => this.conductor.resume(PAUSE_REASON);

    button.addEventListener("click", onClick);
    button.addEventListener("mouseleave", onLeave);
    this.cleanups.push(() => {
      button.removeEventListener("click", onClick);
      button.removeEventListener("mouseleave", onLeave);
    });
  }
}
